import { ErrorWrapper, ResponseWrapper } from '../util'
import { BaseService } from './../base'

export class DocumentService extends BaseService {
  static get entity() {
    return 'document'
  }
  static get name() {
    return 'document'
  }

  
  static async putFile(id,file) {
    try {
      const response = await this.request().post(`${this.profile}/${this.entity}/changeFile/${id}`,file)
      return new ResponseWrapper(response, response.data[this.name])
    } catch (error) {
      throw new ErrorWrapper(error)
      // return;
    }
  }
  static async getDocumentsFindByUserCellar(id,page=1) {
    try {
      const response = await this.request().get(`${this.profile}/${this.entity}/find_by_user_id_cellar_id/${id}?page=${page}`)
      return new ResponseWrapper(response, response.data[this.name])
    } catch (error) {
      throw new ErrorWrapper(error)
      // return;
    }
  }

  static async getDocumentsFindByDirectory(id,page=1) {
    try {
      const response = await this.request().get(`${this.profile}/${this.entity}/find_by_directory_id/${id}?page=${page}`)
      return new ResponseWrapper(response, response.data[this.name])
    } catch (error) {
      throw new ErrorWrapper(error)
      // return;
    }
  }

  static async getTrashByCellarId(cellarId,page) {
    try {
      const response = await this.request().get(`${this.profile}/${this.entity}/trash/${cellarId}?page=${page}`)
      return new ResponseWrapper(response, response.data[this.name])
    } catch (error) {
      throw new ErrorWrapper(error)
      // return;
    }
  }

  static async getCountByCellarId(id) {
    try {
      const response = await this.request().get(`${this.profile}/${this.entity}/count_by_cellar_id/${id}`)
      return new ResponseWrapper(response, response.data[this.name])
    } catch (error) {
      throw new ErrorWrapper(error)
      // return;
    }
  }

  static async getCountByDirectoryId(id) {
    try {
      const response = await this.request().get(`${this.profile}/${this.entity}/count_by_directory_id/${id}`)
      return new ResponseWrapper(response, response.data[this.name])
    } catch (error) {
      throw new ErrorWrapper(error)
      // return;
    }
  }

  static async getCountDeletedByCellarId(id) {
    try {
      const response = await this.request().get(`${this.profile}/${this.entity}/count_deleted_by_cellar_id/${id}`)
      return new ResponseWrapper(response, response.data[this.name])
    } catch (error) {
      throw new ErrorWrapper(error)
      // return;
    }
  }
  static async downloadReport(dateStart, dateEnd, cellarId) {
    try {
      console.log('download');
      const response = await this.request().get(`${this.profile}/${this.entity}/export/${dateStart}/${dateEnd}/${cellarId}`, {
        responseType: 'blob'
      })
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      throw new ErrorWrapper(error)
      // return;
    }
  }
  static async getFindByDocumentAll(text,page) {
    try {
      const response = await this.request().get(`${this.profile}/${this.entity}/find_by_document_all/${text}?page=${page}`)
      return new ResponseWrapper(response, response.data[this.name])
    } catch (error) {
      throw new ErrorWrapper(error)
      // return;
    }
  }
}